import { render, staticRenderFns } from "./dangerous-cargo.vue?vue&type=template&id=634f1898&"
import script from "./dangerous-cargo.vue?vue&type=script&lang=js&"
export * from "./dangerous-cargo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports